import { Link } from "@bca/ui-library";

export const itemCleanedLink = (CMSdomainURL, vrmNumber, isHPILink = false) => {
  let searchParams = new URL(window.location.href).searchParams;
  searchParams.delete("vrm");
  searchParams.append("searchVersion", "new");
  const url = searchParams.toString();

  const defaultURL = `${CMSdomainURL}lot/${vrmNumber}?${url}`;
  const HPILink = new URL(`#hpi-spec-check-table`, defaultURL).href;

  return isHPILink ? HPILink : defaultURL;
};

const LinkToDetailsPage = ({
  CMSdomainURL,
  vrmNumber,
  dataTestId,
}: {
  CMSdomainURL: string;
  vrmNumber: string;
  dataTestId: string;
}) => {
  return (
    <Link
      data-testid={dataTestId}
      href={itemCleanedLink(CMSdomainURL, vrmNumber)}
      css={`
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 0;
      `}
    >
      {}
    </Link>
  );
};

export default LinkToDetailsPage;
